import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Collapse } from 'reactstrap';
import PriorRunItem from './priorRunItem';
import { formatTimestamp } from './qualityAgentHelpers';
const RunDetailsSection = ({
  summary,
  priorRunsArray
}) => {
  var _summary$assessment;
  const [isPriorRunsOpen, setIsPriorRunsOpen] = useState(false);
  const handleTogglePriorRuns = useCallback(() => {
    setIsPriorRunsOpen(prev => !prev);
  }, []);
  return /*#__PURE__*/React.createElement(Card, {
    className: "shadow-sm h-100"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "bg-white"
  }, /*#__PURE__*/React.createElement(CardTitle, {
    tag: "h5",
    className: "mb-0 quality-agent__card-title"
  }, "Run Details")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Timestamp"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium"
  }, formatTimestamp(summary.timestamp))), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Assessment"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-capitalize"
  }, ((_summary$assessment = summary.assessment) === null || _summary$assessment === void 0 ? void 0 : _summary$assessment.replace(/_/g, ' ')) || '—')), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Total Checks"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium"
  }, summary.totalChecks || 0)), priorRunsArray.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center quality-agent__prior-runs-toggle",
    onClick: handleTogglePriorRuns,
    role: "button",
    tabIndex: 0,
    onKeyDown: e => e.key === 'Enter' && handleTogglePriorRuns()
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small mb-0"
  }, "Prior Runs (", priorRunsArray.length, ")"), /*#__PURE__*/React.createElement("span", {
    className: "text-muted small"
  }, isPriorRunsOpen ? '▲' : '▼')), /*#__PURE__*/React.createElement(Collapse, {
    isOpen: isPriorRunsOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, priorRunsArray.map(run => /*#__PURE__*/React.createElement(PriorRunItem, {
    key: run.id,
    runId: run.id,
    run: run
  })))))));
};
RunDetailsSection.propTypes = {
  summary: PropTypes.shape({
    timestamp: PropTypes.string,
    assessment: PropTypes.string,
    totalChecks: PropTypes.number
  }).isRequired,
  priorRunsArray: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })).isRequired
};
export default RunDetailsSection;